import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-wells-summary-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './wells-summary-tab.component.html',
  styleUrls: ['./wells-summary-tab.component.scss'],
})
export class WellsSummaryTabComponent {
  @Input() isMultiWellMode = false;
  @Input() multiWellCards: any[] = [];
  @Input() wellsIdentification: any[] = [];
  @Input() wellsBackgroundFields: any[] = [];
  @Input() wellsBackgroundLists: any[] = [];
}
